import { STATUSES_GROUPS } from "@js-app/const/operation-statuses-groups";

export const AVAILABLE_FILTER_TYPES = [
  {
    id: "status",
    name: "analytics.filter.filter-type.status",
  },
  {
    id: "cardPan",
    name: "analytics.filter.filter-type.cardPan",
  },
  {
    id: "fullName",
    name: "analytics.filter.filter-type.fullName",
  },
  {
    id: "amount",
    name: "analytics.filter.filter-type.amount",
  },
  {
    id: "billId",
    name: "analytics.filter.filter-type.order-number",
  },
  {
    id: "partnerTransactionId",
    name: "analytics.filter.filter-type.partnerTransactionId",
  },
  {
    id: "operationId",
    name: "analytics.filter.filter-type.operationId",
  },
  {
    id: "phone",
    name: "bills.filter.filter-type.phone",
  },
  {
    id: "email",
    name: "bills.filter.filter-type.email",
  },
  {
    id: "mid",
    name: "analytics.filter.filter-type.mid",
  },
];
export const ADDITIONAL_FILTERS = {
  status: {
    value: null,
    options: Object.values(STATUSES_GROUPS),
    component: "CustomSelect",
    title: "analytics.filter.search-value",
  },
  cardPan: {
    value: null,
    component: "BaseTextInput",
    title: "analytics.filter.search-value",
    validate() {
      if (this.value.includes("*")) {
        this.value = this.value.replace(/[*]+/, "%");
      }
    },
  },
  billId: {
    value: null,
    component: "BaseTextInput",
    title: "analytics.filter.search-value",
  },
  fullName: {
    value: null,
    component: "BaseTextInput",
    title: "analytics.filter.search-value",
  },
  amount: {
    value: {
      from: null,
      to: null,
    },
    component: "AmountRangeInput",
    title: "analytics.filter.search-value",
    resetValue: {
      from: null,
      to: null,
    },
    validate() {
      if (parseFloat(this.value.from) > parseFloat(this.value.to)) {
        this.value = {
          from: this.value.to,
          to: this.value.from,
        };
      }
    },
  },
  partnerTransactionId: {
    value: null,
    component: "BaseTextInput",
    title: "analytics.filter.search-value",
  },
  operationId: {
    value: null,
    component: "BaseTextInput",
    title: "analytics.filter.search-value",
  },
  phone: {
    value: null,
    component: "BaseTextInput",
    title: "analytics.filter.search-value",
  },
  email: {
    value: null,
    component: "BaseTextInput",
    title: "analytics.filter.search-value",
  },
  mid: {
    value: null,
    component: "CustomSelect",
    title: "analytics.filter.search-value",
  },
};
